export const stoli_podkatnie = {
    metall_type: [
        {
            actual: true,
            name: "stol__psm__500x500",
            pageName: "psm",
            tempName: "psm",
            glbPath: "stoli_podkatnie/",
            glbName: "stol__psm.glb",
            nextMenu: "psm",
            menuTitle: "Стол подкатной (ПСМ)",
            title: "Стол подкатной (ПСМ)",
            imgName: "psm.webp",
            allArrTable: "allStoliPodkatnie",
            defaultWidth: 500,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stol__pst__500x500",
            pageName: "pst",
            tempName: "pst",
            glbPath: "stoli_podkatnie/",
            glbName: "stol__pst.glb",
            nextMenu: "pst",
            menuTitle: "Стол подкатной (ПСТ)",
            title: "Стол подкатной (ПСТ)",
            imgName: "pst.webp",
            allArrTable: "allStoliPodkatnie",
            defaultWidth: 500,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "stol__psp__500x700",
            pageName: "psp",
            tempName: "psp",
            glbPath: "stoli_podkatnie/",
            glbName: "stol__psp.glb",
            nextMenu: "psp",
            menuTitle: "Стол подкатной (ПСП)",
            title: "Стол подкатной (ПСП)",
            imgName: "psp.webp",
            allArrTable: "allStoliPodkatnie",
            defaultWidth: 500,
            defaultDepth: 500,
        },
    ],
    construct_type: [
        {
            actual: true,
            name: "stol__psp_kp__500x700",
            pageName: "psp_kp",
            tempName: "psp_kp",
            glbPath: "stoli_podkatnie/",
            glbName: "stol__psp_kp.glb",
            nextMenu: "psp_kp",
            menuTitle: "Стол подкатной (ПСП-КП)",
            title: "Стол подкатной (ПСП-КП)",
            imgName: "psp_kp.webp",
            allArrTable: "allStoliPodkatnie",
            defaultWidth: 500,
            defaultDepth: 700,
        },
        {
            actual: true,
            name: "stol__ps_kp__500x500",
            pageName: "ps_kp",
            tempName: "ps_kp",
            glbPath: "stoli_podkatnie/",
            glbName: "stol__ps_kp.glb",
            nextMenu: "ps_kp",
            menuTitle: "Стол подкатной (ПС-КП)",
            title: "Стол подкатной (ПС-КП)",
            imgName: "ps_kp.webp",
            allArrTable: "allStoliPodkatnie",
            defaultWidth: 500,
            defaultDepth: 500,
        },
    ],
};
